import { Directive, effect, ElementRef, input, InputSignal, Renderer2 } from "@angular/core";
import { Node }                                                                from "../../_model";

@Directive({
	selector: "[nodeTextColor]"
})
export class NodeTextColorDirective {
	domElement: any;

	nodeTextColor: InputSignal<Node> = input<Node>();

	constructor(private renderer: Renderer2,
		private elementRef: ElementRef) {
		this.domElement = this.elementRef.nativeElement;

		effect(() => {
			const c = this.nodeTextColor();
			this.updateView();
		});

	}

	updateView() {
		const requiredStyles = {};

		if (this.nodeTextColor().textColor) {
			requiredStyles["color"] = "#" + this.nodeTextColor().textColor;
		}

		Object.keys(requiredStyles).forEach(newStyle => {
			this.renderer.setStyle(
				this.domElement, `${newStyle}`, requiredStyles[newStyle]
			);
		});
	}

// Any other logic to be implemented for directive…
}
